angular.module('bmsApp.merrymaids.job').controller('MMJobMainCtrl',
	function (
		$state,
		$scope) {

		let self = $scope.MMJobMainCtrl = {};
		self.jobOrQuote = null;

		$scope.$on('MMCloseJobListSideData', function (e, closeJobData) {
			$scope.closeJobData = closeJobData;
		});


		$scope.exportJobs = function () {
			$scope.$broadcast('mmJobIndexExport', {});
			console.log('mmJobIndexExport');
		};

	});
